<p-toolbar>
  <ng-template #start>
    <div class="gap-3.5 items-center flex">
      <a class="flex sm:gap-4 order-1 flex-col sm:flex-row"
         [routerLink]="['/']"
      >
        <img alt="Albatros Logo"
             class="albatros-logo hidden sm:block"
             src="/assets/images/Albatros_Certificate_Manager_quer_RGB.svg"
        >
        <img alt="Albatros Logo"
             class="albatros-logo block sm:hidden"
             src="/assets/images/Albatros_Certificate_Manager_stacked_RGB_randlos.svg"
        >
      </a>
    </div>
  </ng-template>

  <ng-template #center>
    <ng-container *ngTemplateOutlet="userActions; context: { myClass: 'flex md:hidden' }"/>
  </ng-template>

  <ng-template #end>
    <div class="flex items-center gap-2.5 grow">
      <div class="search-bar grow">
        <div class="flex items-center gap-2.5 grow">
          <div class="md:hidden">
            <button pButton
                    type="button"
                    data-test="header-sidebar-open-button"
                    severity="secondary"
                    variant="outlined"
                    class="collapse-btn"
                    iconOnly
                    (click)="openSidebarDrawer()"
            >
              <i class="pi pi-folder"></i>
            </button>
          </div>
          <albert-search-bar class="grow"
                             placeholder="Search ..."
          />
        </div>
      </div>

      <ng-container *ngTemplateOutlet="userActions; context: { myClass: 'hidden md:flex' }"/>
    </div>
  </ng-template>
</p-toolbar>

<ng-template #userActions
             let-passedClass="myClass"
>
  <div class="items-center gap-2 header-icons pt-3 md:pt-0"
       [ngClass]="passedClass"
  >
    <button pButton
            type="button"
            data-test="header-notifications-button"
            severity="primary"
            variant="outlined"
            class="alerts-btn"
            iconOnly
    >
      <i class="pi pi-bell"></i>
    </button>

    <div class="user-menu-wrapper">
      <p-menu #menu
              styleClass="user-menu"
              [model]="menuItems()"
              [popup]="true"
      />
      <p-overlay-badge data-test="header-user-badge"
                       value="4"
      >
        <p-avatar data-test="header-user-button"
                  [label]="userInitials()"
                  (click)="menu.toggle($event)"
                  (keydown)="menu.toggle($event)"
        />
      </p-overlay-badge>
    </div>

    <div class="toolbar-drawer-button">
      <button pButton
              type="button"
              data-test="header-toolbar-open-button"
              severity="secondary"
              variant="outlined"
              class="collapse-btn"
              iconOnly
              (click)="openToolbarDrawer()"
      >
        <i class="pi pi-bars"></i>
      </button>
    </div>
  </div>
</ng-template>
